import type { ReactNode } from 'react';

import type { JobStatus } from '../types/api';

type Tone = 'ok' | 'warn' | 'err' | 'run' | 'idle';

const JOB_STATUS_TONE: Record<JobStatus, Tone> = {
  draft: 'idle',
  queued: 'idle',
  running: 'run',
  waiting_qc_tts: 'warn',
  waiting_qc_lipsync: 'warn',
  completed: 'ok',
  failed: 'err',
  cancelled: 'idle',
  expired: 'err',
};

const JOB_STATUS_LABEL: Record<JobStatus, string> = {
  draft: 'Черновик',
  queued: 'В очереди',
  running: 'Выполняется',
  waiting_qc_tts: 'Ждёт проверки',
  waiting_qc_lipsync: 'Ждёт проверки',
  completed: 'Готово',
  failed: 'Ошибка',
  cancelled: 'Отменено',
  expired: 'Протухло',
};

function Badge({ tone, children }: { tone: Tone; children: ReactNode }) {
  return <span className={`badge badge--${tone}`}>{children}</span>;
}

export function JobStatusBadge({ status }: { status: JobStatus }) {
  return <Badge tone={JOB_STATUS_TONE[status]}>{JOB_STATUS_LABEL[status]}</Badge>;
}
